import { configureStore } from "@reduxjs/toolkit";

import appointmentReducer from "./appointmentSlice";
import authReducer from "./authSlice";
import lesseeReducer from "./lesseeSlice";
import personReducer from "./personSlice";
import propertyReducer from "./propertySlice";
import userReducer from "./userSlice";
import uiReducer from "./uiSlice";

const store = configureStore({
  reducer: {
    appointment: appointmentReducer,
    auth: authReducer,
    lessee: lesseeReducer,
    person: personReducer,
    property: propertyReducer,
    ui: uiReducer,
    user: userReducer,
  },
});

export default store;
